import { render, staticRenderFns } from "./InvoiceView.vue?vue&type=template&id=38bd6e29&scoped=true"
import script from "./InvoiceView.vue?vue&type=script&lang=js"
export * from "./InvoiceView.vue?vue&type=script&lang=js"
import style0 from "./InvoiceView.vue?vue&type=style&index=0&id=38bd6e29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bd6e29",
  null
  
)

export default component.exports